import { camposDe } from "./DatosCliente";

/* ============================================================================
   CREAR FACTURA · franja de dato faltante

   El correo no bloquea la emisión -- hoy tampoco lo hace, y esta fase no
   cambia ninguna validación. Lo que hace es AVISAR de una consecuencia real:
   sin correo, la factura no se puede enviar por email después de emitirla, y
   eso se descubre cuando ya es irreversible.

   Se pinta sólo cuando falta de verdad. Si no falta nada, no hay franja.
   ========================================================================== */

/** Los avisos que aplican a este paciente/cliente. Vacío = no se pinta nada. */
export function avisosDe(info) {
    const c = camposDe(info);
    if (!c) return [];
    const avisos = [];
    if (!c.correo) {
        avisos.push({
            clave: "correo",
            texto: "Sin correo registrado: la factura no se podrá enviar por email",
        });
    }
    return avisos;
}

export default function AvisoDatoFaltante({ info }) {
    const avisos = avisosDe(info);
    if (avisos.length === 0) return null;

    return (
        <>
            {avisos.map((a) => (
                <div className="fcrear__aviso" key={a.clave} role="status">
                    <span className="fcrear__aviso-texto">{a.texto}</span>
                </div>
            ))}
        </>
    );
}
